import React from "react";
import * as SubframeCore from "@subframe/core";
import { IconButton } from "subframe/components/IconButton";
import { TableCol } from "./TableCol";
import { IconName } from "@subframe/core";

interface ActionItem {
  icon: IconName;
  label: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

interface TableActionCellProps {
  actions: ActionItem[];
  className?: string;
}

export const TableActionCell: React.FC<TableActionCellProps> = ({ 
  actions, 
  className = "" 
}) => {
  return (
    <TableCol width="w-16" className={className} onClick={(e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
    }}>
      <SubframeCore.Popover.Root>
        <SubframeCore.Popover.Trigger asChild={true}>
          <IconButton
            icon="FeatherMoreVertical"
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {}}
          />
        </SubframeCore.Popover.Trigger>
        <SubframeCore.Popover.Portal>
          <SubframeCore.Popover.Content
            side="bottom"
            align="center"
            sideOffset={4}
            asChild={true}
          >
            <div className="flex flex-col items-start gap-1 rounded-md border border-solid border-neutral-border bg-default-background px-3 py-3 shadow-lg">
              <div className="flex w-full flex-col items-start gap-2 px-1 py-1">
                {actions.map((action, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 px-2 py-1 rounded"
                    onClick={action.onClick}
                  >
                    <SubframeCore.Icon
                      className="text-body font-body text-default-font"
                      name={action.icon}
                    />
                    <span className="text-body font-body text-default-font">
                      {action.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </SubframeCore.Popover.Content>
        </SubframeCore.Popover.Portal>
      </SubframeCore.Popover.Root>
    </TableCol>
  );
}; 